import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import {
  GetUspsLocationsErrorResponse,
  GetUspsLocationsRequest,
  GetUspsLocationsSuccessResponse
} from './getUspsLocations.types'

export const getUspsLocationsApi = async (
  request: GetUspsLocationsRequest
): Promise<GetUspsLocationsSuccessResponse> => {
  const response = await configureRequest({
    url: urls.usps.getLocations,
    method: 'GET',
    params: {
      zipCode: request.zipCode,
      radius: (request.radius ?? 10).toString()
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as GetUspsLocationsSuccessResponse
  } else {
    throw response as GetUspsLocationsErrorResponse
  }
}

export default getUspsLocationsApi
